import {readUserAgent, userAgent} from '../../functions/analyseUserAgent';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import AppBar from './AppBar';
import Toolbar, { styles as toolbarStyles } from './Toolbar';
import * as React from 'react'
import { Badge } from '@material-ui/core';
import'./Header.css';

const styles = (theme: {
  palette: { common: { white: any }; secondary: { main: any } };
  spacing: { unit: number };
}) => ({
  title: {
    fontSize: 24,
    color: theme.palette.common.white
  },
  placeholder: toolbarStyles(theme).root,
  toolbar: {
    justifyContent: "space-between"
  },
  left: {
    flex: 1
  },
  leftLinkActive: {
    color: theme.palette.common.white
  },
  right: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end"
  },
  rightLink: {
    fontSize: 16,
    color: theme.palette.common.white,
    marginLeft: theme.spacing.unit * 3
  },
  link: {
    textDecoration: "none"
  }
});
  
function AppAppBar(props: any) {
  const { classes } = props;
  readUserAgent();
  if (userAgent.isApp !== true) {
    return (
      <div>
        {/* {console.log(classes.sizeBasket)} */}
        <AppBar>
          <Toolbar className={classes.toolbar}>
            <div className={classes.left} />
            <Link
              to="/"
              variant="h6"
              color="inherit"
              className={classNames(classes.title, classes.link)}
              // href="/"
            >
              Demo Shop
            </Link>
            <div className={classes.right}>
              <Badge color="secondary" badgeContent={props.sizeWishlist}>
                <Link
                  to="/wishlist"
                  className={classNames(classes.rightLink, classes.link)}
                >
                  Wishlist
                </Link>
              </Badge>
              <Badge color="secondary" badgeContent={props.sizeBasket}>
                <Link
                  to="/basket"
                  className={classNames(classes.rightLink, classes.link)}
                  // href="/basket"
                >
                  Basket
                </Link>
              </Badge>
              <Link
                to="/myaccount"
                color="inherit"
                className={classNames(classes.rightLink, classes.link)}
              >
                My Account
              </Link>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.placeholder} />
      </div>
    );
  } else {
    return null;
  }
}

AppAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AppAppBar);



// WEBPACK FOOTER //
// ./src/components/header/Header.tsx